import { useMemo } from "react"
import CustomGrid from "../../../common/CustomGrid"
import { useFetchGet } from "../../../common/fetchGetApi"
import { FinaltoRoutesName, decimalPlace, timeFormat } from "../utils"
import moment from "moment"


let ColumnData = [
    { field: 'orderId', headerText: 'ID', width: '210', format: 'N' },
    { field: 'time', headerText: 'Time', width: '', format: timeFormat },
    { field: 'instrument', headerText: 'Instrument', width: '' },
    { field: 'side', headerText: 'Side', width: '' },
    { field: 'qty', headerText: 'Qty', width: '', format: decimalPlace() },
    { field: 'price', headerText: 'Price', width: '', format: decimalPlace(5) },
    { field: 'state', headerText: 'State', width: '' },
]


function HistoryOrders({ startTime, endTime }) {
    const { isLoading, apiData = [], serverError } = useFetchGet(`${FinaltoRoutesName.orderHistory}`)

    const customApiData = useMemo(() => {
        const newApiData = apiData?.orders?.map((data) => ({ ...data, time: moment(data.tradeDate).toISOString(), orderId: data.orderId ? String(data.orderId) : '-' }))
        return newApiData || []
    }, [apiData])

    return (
        <>
            <CustomGrid ColumnData={ColumnData} apiData={Array.isArray(customApiData) ? customApiData : []} isLoading={isLoading} />
        </>
    )
}

export default HistoryOrders